<template>
  <div class="empty-box flex-center">
    <img src="@/assets/images/empty.png" alt="no record" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.empty-box {
  height: 60vh;
  img {
    width: 290px;
  }
}
</style>
